"use client";
import { jsx as e } from "react/jsx-runtime";
import { cn as n } from "../../../utils/cn.js";
import { forwardRef as t, memo as c } from "react";
const o = t(
  ({ className: a, children: p, ...l }, r) => /* @__PURE__ */ e(
    "div",
    {
      ref: r,
      className: n(
        "@container scroll-mask-y-popup-gap scrollbar-y-[calc(var(--spacing-popup-padding-y)/2)] gap-popup-gap flex h-full flex-col overflow-x-hidden",
        a
      ),
      ...l,
      children: p
    }
  )
);
o.displayName = "ModalContent";
const f = c(o);
export {
  o as ModalContent,
  f as default
};
